import { FormatHeader4Icon } from './FormatHeader4Icon';

/**
 * author: Austin Andrews
 * id CC669D6C-53AD-43C2-A660-EFF783847D6F
 * name format-header-4
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-header-4.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatHeading4Icon = FormatHeader4Icon;
export default FormatHeading4Icon